<template>
  <section v-if="name === 'film'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="base.title"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="base.subtitle"></el-input>
        </el-form-item>
        <el-form-item label="组件间距">
          <el-switch
            v-model="base.padded"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>
        <el-form-item label="选择视频">
          <Videoselect @change="handleVideoChange" :data="data[0]"></Videoselect>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
  import Videoselect from '@/components/videoselect/index'

  export default {
    props: {
      res: {
        type: Object,
        default: {}
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        name: '',
        base: {},
        data: []
      }
    },
    components: {
      Videoselect
    },
    methods: {
      setData(val) {
        this.name = val.name
        this.base = val.base
        this.data = val.data
      },
      handleVideoChange (data) {
        this.$emit('change', data)
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// film.vue?283b9142